import { useEffect, useState } from 'react';
import {
  IData,
  IRegion,
  OptionType,
} from '../../../../../shared/types/filters';
import useFilters from '../../../../../utilities/hooks/useFilters';
import FilterPanel from '../../FilterLayout/FilterPanel';
import { useWidgetsModalContext } from '../../../../../shared/providers/WidgetsModalProvider';
import { useDeviceType } from '../../../../../utilities/common/deviceType';
import { FilterKeys } from '../../../../../shared/constants/filter/filter';
import { useFilterData } from '../../../../../utilities/hooks/useFilterData';

const createRegionOption = ({
  countryCode,
  countryName,
}: IRegion): OptionType<string> => {
  return {
    label: countryName,
    value: countryCode,
  };
};

export default function RegionFilter({ orgs }: { orgs: IRegion[] }) {
  const [queryData, setQueryData] = useState<IData>({ countries: [] });
  const { selectedAccorionFilter } = useWidgetsModalContext();
  const isMobile = useDeviceType();
  const {
    regionFilter,
    setRegionFilter,
    selectedOrganisations,
    regionOptions,
    setRegionOptions,
  } = useFilters();
  const { configData } = useFilterData();

  useEffect(() => {
    if (orgs) {
      setQueryData({
        teams: [],
        countries: orgs,
      });
    }
  }, [orgs]);

  useEffect(() => {
    configData &&
      Array.from(selectedOrganisations.values()).every((value) => !value) &&
      setQueryData(configData);
  }, [configData, selectedAccorionFilter]);

  useEffect(() => {
    const options =
      queryData?.countries?.map((option) => createRegionOption(option)) ?? [];
    setTimeout(() => {
      setRegionOptions(options);
    }, 100);
  }, [queryData?.countries]);

  function getSelectedRegions() {
    const selected = [] as OptionType<string>[];
    regionFilter.forEach((regionId) => {
      const res = regionOptions.find(({ value }) => value === regionId);
      if (res) {
        selected.push(res);
      }
    });
    return selected;
  }

  const isRegionSelected = (id: string) =>
    !!regionFilter.find((regionId) => regionId === id);

  function onRegionChange(id: string) {
    const selectedRegion = regionFilter.find((regionId) => regionId === id);
    if (selectedRegion) {
      setRegionFilter(regionFilter.filter((regionId) => regionId !== id));
    } else {
      setRegionFilter([...regionFilter, id]);
    }
  }

  const selectAll = (
    isChecked: boolean,
    optionsToSelect: any,
    isMatching?: boolean,
  ) => {
    if (isChecked || (!isChecked && optionsToSelect.length === 0)) {
      const updatedRegions = isMatching
        ? regionFilter.filter((id) => !optionsToSelect.includes(id))
        : [];
      setRegionFilter(updatedRegions);
    } else if (optionsToSelect.length > 0) {
      setRegionFilter(
        isMatching
          ? [...regionFilter, ...optionsToSelect.map(String)]
          : optionsToSelect,
      );
    } else setRegionFilter(regionOptions.map((region) => region.value));
  };

  if (!queryData?.countries) {
    return null;
  }

  return (
    <FilterPanel<string>
      name="region"
      filterKey={FilterKeys.region}
      options={regionOptions}
      isSelected={isRegionSelected}
      onSelectedChange={onRegionChange}
      selectedItems={getSelectedRegions()}
      selectAllItems={selectAll}
      flatItemArray={regionOptions}
    />
  );
}
